/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs */

const en_iframe_remote_subtitle_fetch_failed_error = /** @type {(inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to fetch subtitle file: ${i?.status}`)
};

const fr_iframe_remote_subtitle_fetch_failed_error = /** @type {(inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de recuperation du fichier de sous-titres : ${i?.status}`)
};

const de_iframe_remote_subtitle_fetch_failed_error = /** @type {(inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Untertiteldatei konnte nicht abgerufen werden: ${i?.status}`)
};

const it_iframe_remote_subtitle_fetch_failed_error = /** @type {(inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile recuperare il file dei sottotitoli: ${i?.status}`)
};

const ru_iframe_remote_subtitle_fetch_failed_error = /** @type {(inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить файл субтитров: ${i?.status}`)
};

const es_iframe_remote_subtitle_fetch_failed_error = /** @type {(inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo obtener el archivo de subtítulos: ${i?.status}`)
};

const zh_cn2_iframe_remote_subtitle_fetch_failed_error = /** @type {(inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`获取字幕文件失败：${i?.status}`)
};

const ja_iframe_remote_subtitle_fetch_failed_error = /** @type {(inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`字幕ファイルの取得に失敗しました: ${i?.status}`)
};

const hi_iframe_remote_subtitle_fetch_failed_error = /** @type {(inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`उपशीर्षक फ़ाइल प्राप्त करने में विफल: ${i?.status}`)
};

const pt_pt2_iframe_remote_subtitle_fetch_failed_error = /** @type {(inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao obter o arquivo de legenda: ${i?.status}`)
};

/**
* | output |
* | --- |
* | "Failed to fetch subtitle file: {status}" |
*
* @param {Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_fetch_failed_error = /** @type {((inputs: Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Fetch_Failed_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_subtitle_fetch_failed_error(inputs)
	if (locale === "de") return de_iframe_remote_subtitle_fetch_failed_error(inputs)
	if (locale === "it") return it_iframe_remote_subtitle_fetch_failed_error(inputs)
	if (locale === "ru") return ru_iframe_remote_subtitle_fetch_failed_error(inputs)
	if (locale === "es") return es_iframe_remote_subtitle_fetch_failed_error(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_subtitle_fetch_failed_error(inputs)
	if (locale === "ja") return ja_iframe_remote_subtitle_fetch_failed_error(inputs)
	if (locale === "hi") return hi_iframe_remote_subtitle_fetch_failed_error(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_subtitle_fetch_failed_error(inputs)
	return en_iframe_remote_subtitle_fetch_failed_error(inputs)
});